import {
  beEmailCheckupImageCheck,
  beEmailCheckupLinkCheck
} from 'Api/beEmailCheckupApi'
import { beEmailMessageApiGetMessageLinks } from 'Api/beEmailMessageApi'
import { beMessGetMessageDetails } from 'Api/BeMessApi'
import { beSendGoCheckSendingProgress } from 'Api/beSendGoApi'

export async function getMessageDetails (idMessage) {
  const {
    IdMessage: id,
    MessageType: messageType,
    IsBee: isBee,
    Subject: subject,
    IdCampaign: idCampaign,
    TrackingInfo: trackingInfo
  } = await beMessGetMessageDetails(idMessage)

  return { id, messageType, isBee, subject, idCampaign, trackingInfo }
}

export async function isSendingMessage (idMessage) {
  const { Value } = await beSendGoCheckSendingProgress(idMessage)
  return Value
}

export async function getMessageLinks (idMessage) {
  const {
    TrackCustomParams: customParams,
    Items: links
  } = await beEmailMessageApiGetMessageLinks(idMessage)
  return { customParams, links }
}

export async function checkupImageCheck (imageUrl) {
  const {
    IsReachable: reachability,
    Action: action,
    Issues: issues
  } = await beEmailCheckupImageCheck({ Url: imageUrl })
  return { reachability, action, issues }
}

export async function checkupLinkCheck (linkUrl) {
  const {
    IsReachable: reachability,
    Action: action,
    Issues: issues
  } = await beEmailCheckupLinkCheck({ Url: linkUrl })
  return { reachability, action, issues }
}
